<template>
  <div id="index" v-cloak>
    <!--  <Hezuo></Hezuo>  -->

    <div class="visible-xs min_index">
      <div class="flex_end top_head">
        <!-- remind -->
        <div v-if="user.id" class="login_button " :class="{'unread':user.read == 0}">
          <i @click.stop="message"><img src="@/assets/img/message.png" alt=""></i>
        </div>
      </div>
      <!-- 头像 -->
      <div class="user_div flex_between" v-if="USER().id">
        <i class="portrait">
          <el-image :src="user.image" :preview-src-list="srclist" lazy>
          </el-image>
          <!-- <img
            :src="user.image"
            alt=""
          > -->

        </i>
        <div class="user_text">
          <div class="user_top flex_between" v-if="user.check_status == 1">
            <span class="user_name">{{user.name}}</span>
            <router-link to="/m_personal" class="user_right flex_center">
              完善信息 <i><img src="@/assets/img/rigth_icon.png" alt=""></i>
            </router-link>
          </div>
          <div class="flex_start flex_items user_tag">
            <div class="tag_li flex_center">
              <i><img src="@/assets/img/huangguan.png" alt=""></i>
              <span>
                {{MembershipType}}
              </span>
            </div>
            <div class="tag_li flex_center">
              <i><img src="@/assets/img/zhuanshi.png" alt=""></i>
              <span class="integral">{{user.score}}</span>积分
            </div>
          </div>
        </div>
      </div>
      <div v-else class="user_div flex_between" @click.stop="login">
        <i class="portrait"><img src="@/assets/img/app_logo.png" alt=""></i>
        <div class="user_text">
          <div class="user_top flex_between">
            <span class="user_name">去登录</span>
          </div>
        </div>
      </div>
      <!-- 菜单 -->
      <div class="flex_between menu" v-if="USER().id">
        <router-link to="/m_focus" class="menu_li">
          <h5>{{user.follow}}</h5>
          <span>关注</span>
        </router-link>
        <router-link to="/m_collection" class="menu_li">
          <h5>{{user.collect}}</h5>
          <span>收藏</span>
        </router-link>
        <router-link to="/m_comments" class="menu_li">
          <h5>{{user.comment}}</h5>
          <span>评论</span>
        </router-link>
      </div>
      <div class="button_ul" v-if="USER().id && USER().check_status == 1">
        <router-link to="/m_integral" class="button_li flex_between">
          <i><img src="@/assets/img/jifen.png" alt=""></i>
          <div class="flex_between li_right">
            <span>积分记录</span>
            <i><img src="@/assets/img/rigth_hui.png" alt=""></i>
          </div>
        </router-link>
        <router-link to="/m_rules" class="button_li flex_between">
          <i><img src="@/assets/img/guizhe.png" alt=""></i>
          <div class="flex_between li_right">
            <span>规则详情</span>
            <i><img src="@/assets/img/rigth_hui.png" alt=""></i>
          </div>
        </router-link>
        <router-link to="/m_setUp" class="button_li flex_between">
          <i><img src="@/assets/img/shezhi.png" alt=""></i>
          <div class="flex_between li_right">
            <span>设置</span>
            <i><img src="@/assets/img/rigth_hui.png" alt=""></i>
          </div>
        </router-link>
        <router-link to="/m_content_file" class="button_li flex_between" v-if="user.is_show_file == 1">
          <i><img src="@/assets/img/file.png" alt=""></i>
          <div class="flex_between li_right">
            <span>内容文件</span>
            <i><img src="@/assets/img/rigth_hui.png" alt=""></i>
          </div>
        </router-link>
      </div>
      <div class="child flex_cloumn"  v-else>
          <div v-if="USER().check_status == 0" style="margin-bottom:5px;">审核状态：待审核</div>
          <br>
          <div v-if="USER().check_status == 2" style="margin-bottom:5px">审核状态：审核拒绝</div>
          <br>
          <div v-if="USER().check_status == 2">审核备注：{{USER().check_remark}}</div><br>
          <div v-if="USER().check_status == 0 || USER().check_status == 2"><el-button type="primary" size="mini"  @click="resubmit">重新提交</el-button></div>
      </div>
      <!-- <div class="flex menu" v-if="user.check_status == 2">
          <div style="">
           
          </div>
        </div> -->
      <!-- 提示注册弹窗 -->
      <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
      <!-- 尾部 -->
      <MinFooter :headIndex="5"></MinFooter>
    </div>
  </div>
</template>

<script>
import Hezuo from '@/components/tool/m_hezuo.vue'
import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
import MinFooter from "@/components/m_assembly/MinFooter.vue"; //尾部模块
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "m_my",
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      is_pc: true, //是否是pc端打开
      user: {},//用户信息
      srclist: [],
      isimgshow: false
    };
  },
  computed: {
    MembershipType: function () {
      return this.MembershipGrade(this.user.plus);
    }
  },
  components: {
    MinHeader,
    MinFooter, LoginPrompt, Hezuo
  },
  watch: {
  },
  methods: {
    resubmit(){
      this.$store.commit('setPhone', this.user.mobile)
      this.$store.commit('setRepeat', 1)
      this.$router.replace("/m_registered");
    },
    login() {
      this.$router.push("/m_password");
    },
    judgeUser() {//判断用户数据
      if (!this.USER()) {
        this.$refs.prompt.popupFun();
        return false;
      }
      return true;
    },
    message() {//消息
      if (!this.judgeUser()) {
        return false;
      }
      this.$router.push("/m_message");
    },
    promptFun() {//提示弹窗回调
      this.$router.replace("/m_registered");
    },
    getUser() {
       this.$post('refresh', {
        mobile:this.USER().mobile
      }).then(res => {
         this.user = res.data
      })
      this.user.image = this.user.userimage ? this.user.userimage : this.user.headimage
      this.user.name = this.user.username ? this.user.username : this.user.nickname
      this.srclist.push(this.user.image)
    },

  },
  created() {
    this.getUser();
  },
  mounted() {
    this.$post('refresh', {
        mobile:this.USER().mobile
      }).then(res => {
         this.user = res.data
      })
    if (this.user) {
      this.$nextTick(res => {
        setTimeout(() => {
          this.isimgshow = true
        }, 200);
      })
    }
    document.title = '麻醉眼界';
    if (this.GetRequest().code) {
      window.location.href = this.$VIEW_URL;
    }
    this.getShare();
    this.getUser();
    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }

  }
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}
.child {
  text-align: center;
  width: 100vw;
  height: 120px;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}
#index {
  padding-top: 0;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem !important;
}

/* 头部 */
.top_head {
  padding: 2rem 1.6rem 0 1.6rem;
}

.login_button {
  cursor: pointer;
  margin-left: 15px;
}

.login_button > i {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #eeeeee;
  position: relative;
}

.login_button > i > img {
  width: 18px;
}

.login_button > span {
  font-size: 16px;
  color: #333;
  white-space: nowrap;
}

.login_button.unread i::after {
  position: absolute;
  top: 0;
  right: 0;
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background: #f24d5b;
}

/* 头像 */
.user_div {
  padding: 1.9rem 2rem;
}

.user_div .portrait {
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  background: #a0a0a0;
  overflow: hidden;
}

.user_div .portrait > img {
  width: 7.5rem;
  height: 7.5rem;
  object-fit: cover;
}

.user_div .user_text {
  flex: 1;
  margin-left: 2rem;
}

.user_text .user_top {
}

.user_text .user_top .user_name {
  font-size: 1.8rem;
  font-weight: bold;
  flex: 1;
}

.user_text .user_top .user_right {
  font-size: 1.2rem;
  color: #333;
  line-height: 1em;
}

.user_text .user_top .user_right i {
  width: 0.9rem;
  margin-left: 0.4rem;
  line-height: 1em;
}

.user_tag {
  margin-top: 2rem;
}

.user_tag .tag_li {
  font-size: 1.1rem;
  color: #333;
  margin-right: 1.5rem;
}

.user_tag .tag_li i {
  width: 1.75rem;
  margin-right: 0.5rem;
}

.user_tag .tag_li .integral {
  color: #f5ab16;
  margin-right: 0.2rem;
}

/* 菜单 */
.menu {
  padding: 1.2rem 2rem;
}

.menu .menu_li {
  width: 33%;
  text-align: center;
  border-right: 0.05rem solid #dfdfdf;
}

.menu .menu_li:last-child {
  border: 0;
}

.menu .menu_li > h5 {
  font-size: 2.1rem;
  font-weight: bold;
  margin-bottom: #333333;
}

.menu .menu_li > span {
  font-size: 1.4rem;
  color: #888;
}

.button_ul {
  margin-top: 2rem;
}

.button_ul .button_li {
  padding-left: 1.5rem;
  margin-bottom: 0.5rem;
}

.button_ul .button_li > i {
  width: 2rem;
  margin-right: 1.8rem;
}

.button_ul .button_li .li_right {
  flex: 1;
  height: 5rem;
  border-bottom: 0.05rem solid #dfdfdf;
  padding: 0 3rem 0 0.1rem;
}

.li_right > span {
  font-size: 1.4rem;
  color: #333;
}

.li_right > i {
  width: 0.75rem;
}
::v-deep .el-image-viewer__close {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_my.vue